import { HiMagnifyingGlass } from "react-icons/hi2";

export const SearchIcon = ({ width, height, color, ...props }) => (
  <HiMagnifyingGlass
    size={width || height || 20}
    color={color || "#3e50f7"}
    {...props}
  />
);
